import React from "react";
import { Typography } from "antd";
import meses from "../../assets/beneficios/meses-sin-intereses.png";
import tarjeta from "../../assets/beneficios/pagos con tarjeta.png";
import vendedores from "../../assets/beneficios/vendedores-validados.png";
import productos from "../../assets/beneficios/productos-calidad.png";
import "./Beneficios.scss";

const { Text } = Typography;

const Beneficios = () => {
  const data = [
    { img: meses, title: "Meses sin intereses" },
    { img: tarjeta, title: "Pagos con tarjeta" },
    { img: vendedores, title: "Vendedores validados" },
    { img: productos, title: "Productos de calidad" },
  ];

  return (
    <div className="benefits-horizontal-scroll">
      <div className="scroll-wrapper">
        {data.map((item, index) => (
          <div className="benefit-pill" key={index}>
            <img src={item.img} alt={item.title} className="pill-icon" />
            <Text className="pill-text">{item.title}</Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Beneficios;